function Error(){
    return(
        <div className="flex justify-center items-center text-3xl text-white font-mono">
            Error-404 not found
        </div>
    )
}

export default Error;